<ng-template #Modal let-data let-ref="modalRef" >
  <nb-card  *ngIf="orderDetail" class="staffInfoTemplate " style="max-width: 800px">
    <nb-card-header style="display: flex; justify-content: space-between; align-items: center;">
      <span>查看訂單</span>
      <button nbButton (click)="AdjustTransactionMo.onOpen(orderDetail)" *ngIf="ORD_Status_ID != 3">調整帳務</button>
    </nb-card-header>
    
    <nb-card-body>

      <!-- 訂單資訊 -->
      <div class="row">
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">訂單編號</label>
          <!-- <input nbInput disabled fullWidth [ngModel]="orderDetail.ORDNo"> -->
          <h6>{{orderDetail.ORDNo}}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">取餐號</label>
          <!-- <input nbInput disabled fullWidth [ngModel]="orderDetail.ORDNo"> -->
          <h6>{{orderDetail.PickupNumber}}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">接單時間</label>
          <!-- <input nbInput disabled fullWidth [ngModel]="orderDetail.CreateDate"> -->
          <h6>{{orderDetail.CreateDate }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">用餐方式</label>
          <h6>{{orderDetail.ORDKindName}}</h6>
          <!-- <nb-select name="orderType" [(ngModel)]="orderDetail.ORD_Kind_ID" disabled>
          <nb-option *ngFor="let e of ordTypeList" [value]="e.value">{{e.content}}</nb-option>
        </nb-select> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">訂單狀態</label>
          <h6>{{orderDetail.ORDStatusName}}</h6>
          <!-- <nb-select name="ORD_Status_ID" [(ngModel)]="orderDetail.ORD_Status_ID" disabled>
          <nb-option *ngFor="let e of ORD_Status_List" [value]="e.value">{{e.content}}</nb-option>
        </nb-select> -->
        </div>


        <div class="col-sm-6 xd" >
          <label class="label col-sm-12 col-form-label">顧客名稱</label>
          <h6> {{ orderDetail.Name ? orderDetail.Name : '無'}}</h6>          
        </div>

        <div class="col-sm-6 xd" >
          <label class="label col-sm-12 col-form-label">顧客電話</label>
          <h6> {{ orderDetail.Phone ? orderDetail.Phone : '無'}}</h6>          
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID!=3">
          <label class="label col-sm-12 col-form-label">
            <span *ngIf="orderDetail.ORD_Kind_ID==1">外帶</span>
            <span *ngIf="orderDetail.ORD_Kind_ID==2">外送</span>
            <span *ngIf="orderDetail.ORD_Kind_ID==5">自取</span>時間
          </label>
          <h6>{{orderDetail.MealTime  ? orderDetail.MealTime : '無' }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID==2">
          <label class="label col-sm-12 col-form-label">外送地址</label>
          <h6> {{ orderDetail.Address ? orderDetail.Address : '無'}}</h6>          
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID==3">
          <label class="label col-sm-12 col-form-label">內用桌號</label>
          <h6> {{ orderDetail.TableName ? orderDetail.TableName : '無'}}</h6>          
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID==3">
          <label class="label col-sm-12 col-form-label">內用人數 (大人 | 小孩)</label>
          <h6> {{ orderDetail.Adults }} | {{ orderDetail.Children }}</h6>          
        </div>

        <div class="col-sm-12 xd">
          <label class="label col-sm-12 col-form-label">備註</label>
          <h6> {{ orderDetail.Note ? orderDetail.Note : '無'}}</h6>
          <!-- <textarea rows="5" type="text" nbInput fullWidth [(ngModel)]="orderDetail.Note"> </textarea>-->
        </div>

        <div class="col-sm-12 xd" *ngIf="orderDetail.EmployeeName">
          <label class="label col-sm-12 col-form-label">結帳人員</label>
          <h6> {{ orderDetail.EmployeeName ? orderDetail.EmployeeName : '無'}}</h6>
        </div>

      </div>
      <!-- 付款資訊 -->
      <div class="row">          
        <div class="titleHr">
          <span>付款資訊</span>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">付款狀態</label>
          <h6>{{orderDetail.PayStatusName}}</h6>
          <!-- <nb-select name="ORD_PayStatus_ID" [(ngModel)]="orderDetail.ORD_PayStatus_ID" disabled>
          <nb-option *ngFor="let e of ORD_Pay_Status_List" [value]="e.value">{{e.content}}</nb-option>
        </nb-select> -->
        </div>

        <ng-container *ngFor="let e of orderDetail.PaymentKindData">
          <div class="col-sm-6 xd" >
            <label class="label col-sm-12 col-form-label">{{e.PaymentKindName}} : 實收 | 找零</label>
            <h6>{{e.ReceivedCash  | currency  : null : true :'1.0'}} | {{e.ChangeCash  | currency  : null : true :'1.0'}}</h6>          
          </div>
          <!-- <div class="col-sm-6 xd" *ngIf="e.SYS_PaymentKind_ID != 2">
            <label class="label col-sm-12 col-form-label">{{e.PaymentKindName}}支付</label>
            <h6>{{e.Cash  | currency  : null : true :'1.0'}}</h6>          
          </div> -->
        </ng-container>

        <!-- <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">支付方式</label>
          <h6>{{orderDetail.PaymentKindName}}</h6>          
        </div> -->


        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">小計</label>
          <h6> {{ orderDetail.Cash | currency  : null : true :'1.0'}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.Cash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">折扣</label>
          <h6> {{ orderDetail.DiscountCash | currency  : null : true :'1.0'}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.DiscountCash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">服務費</label>
          <h6> {{ orderDetail.ServiceFee | currency  : null : true :'1.0'}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ServiceFee" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">運費</label>
          <h6> {{ orderDetail.ShippingFee | currency  : null : true :'1.0'}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ShippingFee" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">總計</label>
          <h6> {{ orderDetail.TotalCash | currency  : null : true :'1.0'}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
        </div>
        


       
      </div>

      <!-- 刷卡資訊 -->
      <div class="row" *ngIf="orderDetail.NCCCData != null">          
        <div class="titleHr">
          <span>刷卡資訊</span>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">商店代號</label>
          <h6>{{orderDetail.NCCCData.MerchantID}}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">端末機編號</label>
          <h6> {{ orderDetail.NCCCData.TerminalID}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.Cash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">卡別</label>
          <h6> {{ orderDetail.NCCCData.CardType}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.DiscountCash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">卡號</label>
          <h6> {{ orderDetail.NCCCData.CardNo}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ServiceFee" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">日期</label>
          <h6> {{ orderDetail.NCCCData.CreateDate}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ShippingFee" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">授權碼</label>
          <h6> {{ orderDetail.NCCCData.ApprovalNo}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">調閱編號</label>
          <h6> {{ orderDetail.NCCCData.ReceiptNo}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">批次編號</label>
          <h6> {{ orderDetail.NCCCData.BatchNo}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">刷卡金額</label>
          <h6> {{ orderDetail.NCCCData.TransAmount}}</h6>
          <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
        </div>
        


       
      </div>


      <div class="row">          
        <div class="titleHr">
          <span>發票資訊</span>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">開立狀態</label>
          <h6> {{ orderDetail.InvStatusName }}</h6>
        </div> 

        <ng-container *ngIf="orderDetail.InvStatusName != '未開立'">

       
          <div class="col-sm-6 xd" >
            <label class="label col-sm-12 col-form-label">發票號碼</label>
            <h6> {{ orderDetail.InvoiceNumber }}</h6>
          </div>   
          
          <div class="col-sm-6 xd" >
            <label class="label col-sm-12 col-form-label">開立POS機</label>
            <h6> {{ orderDetail.POSName }}</h6>
          </div> 


          <div class="col-sm-6 xd" *ngIf="orderDetail.VoidReason">
            <label class="label col-sm-12 col-form-label">作廢理由</label>
            <h6> {{ orderDetail.VoidReason }}</h6>
          </div> 

          <div class="col-sm-6 xd" *ngIf="orderDetail.VoidTime">
            <label class="label col-sm-12 col-form-label">作廢時間</label>
            <h6> {{ orderDetail.VoidTime }}</h6>
          </div> 

          <div class="col-sm-6 xd" *ngIf="orderDetail.TaxSaleAmount" >
            <label class="label col-sm-12 col-form-label">應稅銷售額</label>
            <h6> {{ orderDetail.TaxSaleAmount  | currency : null : true :'1.0'}}</h6>
          </div> 
          <div class="col-sm-6 xd" *ngIf="orderDetail.TaxFreeSaleAmount">
            <label class="label col-sm-12 col-form-label">免稅銷售額</label>
            <h6> {{ orderDetail.TaxFreeSaleAmount  | currency : null : true :'1.0'}}</h6>
          </div> 
          <div class="col-sm-6 xd" *ngIf="orderDetail.TaxZeroSaleAmount">
            <label class="label col-sm-12 col-form-label">零稅銷售額</label>
            <h6> {{ orderDetail.TaxZeroSaleAmount  | currency : null : true :'1.0'}}</h6>
          </div> 

          <div class="col-sm-6 xd" >
            <label class="label col-sm-12 col-form-label">營業稅</label>
            <h6> {{ orderDetail.TaxAmount  | currency : null : true :'1.0'}}</h6>
          </div> 

        </ng-container>


        <div class="col-sm-6 xd" *ngIf="orderDetail.BarCode">
          <label class="label col-sm-12 col-form-label">
           <span *ngIf="orderDetail.INV_InvoiceKind_ID==3">捐贈碼</span>
           <span *ngIf="orderDetail.INV_InvoiceKind_ID==4">手機載具</span>
           <span *ngIf="orderDetail.INV_InvoiceKind_ID==5">自然人載具</span>
          </label>    
          <h6> {{ orderDetail.BarCode }}</h6>
        </div>              
        
        <div class="col-sm-6 xd" *ngIf="orderDetail.TaxID">
          <label class="label col-sm-12 col-form-label">賣方統編</label>
          <h6> {{ orderDetail.TaxID }}</h6>
        </div> 
        
        <div class="col-sm-6 xd" *ngIf="orderDetail.InvCompanyName">
          <label class="label col-sm-12 col-form-label">公司名稱</label>
          <h6> {{ orderDetail.InvCompanyName }}</h6>
        </div>        

       

        

       

      </div>

      <!-- 訂購人資訊 -->
      <!-- <div class="row">
        <hr />
        <div class="col-sm-12 pb-2">
          <b>訂購人資訊</b>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">訂購人</label>
          <input nbInput disabled fullWidth [(ngModel)]="orderDetail.Name" disabled>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">訂購人電話</label>
          <input nbInput disabled fullWidth [(ngModel)]="orderDetail.Phone" disabled>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">訂購人地址</label>
          <input nbInput fullWidth [(ngModel)]="orderDetail.InvoiceAddr" disabled>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">訂購人Email　</label>
          <input nbInput fullWidth [(ngModel)]="orderDetail.InvoiceEmail" disabled>
        </div>

      </div> -->
      <!-- 收件人資訊 -->
      <!-- <div class="row">
        <hr />
        <div class="col-sm-12 pb-2">
          <b>收件人資訊</b>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">收件人</label>
          <input nbInput fullWidth [(ngModel)]="orderDetail.InvoiceName" disabled>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">收件人電話@@@@@從缺</label>
          <input nbInput fullWidth [(ngModel)]="orderDetail.recipientPhone" disabled>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">收件人地址</label>
          <input nbInput fullWidth [(ngModel)]="orderDetail.InvoiceAddr" disabled>
        </div>
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">收件人Email</label>
          <input nbInput fullWidth [(ngModel)]="orderDetail.InvoiceEmail" disabled>
        </div>

       <div class="col-sm-6 xd">
        <label  class="label col-sm-12 col-form-label">指定取餐時間</label>
        <input nbInput disabled fullWidth [(ngModel)]="orderDetail.specifyTakeTime ">
      </div>
      <div class="col-sm-6 xd">
        <label  class="label col-sm-12 col-form-label">預計取餐時間</label>
        <input readonly nbInput  fullWidth [(ngModel)]="orderDetail.scheduledTakeTime" [nbDatepicker]="scheduledTakeTime" >
        <nb-date-timepicker withSeconds format="yyyy/MM/dd hh:mm:ss" #scheduledTakeTime></nb-date-timepicker>
      </div> 
      </div> -->
      <!-- 商品詳情 -->

      <div class="row">          
        <div class="titleHr">
          <span>商品詳情</span>
        </div>
        <div class="col-xs-12">
          <div  class="mx-0 px-2 row"
            *ngFor="let pd of orderDetail.OrderProductList; let index = index">
            <div class="img-box" style="width: 200px;height: 200px;">
              <img [src]="pd.Image">
            </div>
           
            <div class="col-sm ">
              <label class="label col-sm-12 col-form-label text-info">{{pd.ProductName}} x {{pd.Quantity}}</label>
              <label class="label col-sm-12 col-form-label text-org">
                <span class="mr-3">價格: {{pd.ProductCash  | currency : null : true :'1.0'}} 元</span>  
                <span class="mr-3 text-hint">折扣: {{pd.TotalDiscountCash  | currency : null : true :'1.0'}} 元</span>  
                <span class="mr-3">總計: {{pd.ProductTotalCash  | currency : null : true :'1.0'}} 元</span>  
              </label>
              <div class="label col-sm-12 col-form-label "  style="margin-left: -10px;">
               

                <ng-container   *ngIf="pd"
                  [ngTemplateOutlet]="DeepShow" 
                  [ngTemplateOutletContext]="{$implicit:pd}"                          
                ></ng-container>
                
                
              </div>
              <label class="label col-sm-12 col-form-label text-danger">{{pd.Note}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="orderDetail.DiscountData && orderDetail.DiscountData.length">          
        <div class="titleHr">
          <span>優惠詳情</span>
        </div>
        <div class="col-12 d-flex justify-content-between" *ngFor="let item of orderDetail.DiscountData">
          <b>{{item.DiscountName}}</b><b class="text-org">${{item.TotalDiscountCash}}</b>
        </div>
      </div>



      <div class="row">   
        <div class="titleHr">
          <span>調帳記錄</span>
        </div>

        <div class="col-lg-12 m-0 p-0 overflow-x">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>時間</th>
                <th>員工</th>
                <th>支付別</th>
                <th>紀錄</th>
              </tr>
            </thead>
            <tbody>
              
              <tr *ngFor="let item of adjustAccountList; let index = index">
                <td style="vertical-align: middle;">
                  {{item.CreateDate}}
                </td>
                <td style="vertical-align: middle;">
                  {{item.CreateBy}}
                </td>
                <td style="vertical-align: middle;">
                  {{item.PaymentKindName}}
                </td>
                <td style="vertical-align: middle;">
                  {{item.OriginalCash}}
                  <i class="fas fa-arrow-right" aria-hidden="true"></i> 
                  {{item.Cash}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      


    </nb-card-body>
    <nb-card-footer>
      <div class="">
        <button nbButton (click)="onClose()">關閉</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>


<ng-template #DeepShow let-pd>
  <div style="padding-left: 10px;" *ngFor="let a of pd.AttachItemList">
    • {{a.AttachItemName}} 
    <span *ngIf="a.AttachItemCash" class="text-org">{{a.AttachItemCash  | currency : null : true :'1.0'}}</span>
    <span *ngIf="a.AttachItemQuantity" >x {{a.AttachItemQuantity}}</span>                    
  </div>
  <div style="padding-left: 10px;" *ngFor="let pp of pd.PdList">
    • {{pp.ProductName}} 
    <span *ngIf="pp.ProductCash" class="text-org">{{pp.ProductCash  | currency : null : true :'1.0'}}</span>
    <span *ngIf="pp.Quantity" >x {{pp.Quantity}}</span>
      <div>
        <ng-container *ngIf="pp"
          [ngTemplateOutlet]="DeepShow" 
          [ngTemplateOutletContext]="{$implicit:pp} "                          
        ></ng-container>
      </div>                         
  </div>

</ng-template> 



<!-- 調整交易 -->
<ng-template #AdjustTransactionMoDOM let-data let-ref="dialogRef">
<form #AdjustTransactionMoF="ngForm">
<nb-card class="staffInfoTemplate">
  <nb-card-header>
    調整交易
  </nb-card-header>

  <nb-card-body>
    <div class="row mb-2" *ngFor="let item of AdjustTransactionMo.data.List;let i = index ">
      <div class="row mx-0 col-lg-12">
        <label class="label col-sm-12 col-form-label">{{ item.Name }}</label>
        <p class="col-sm-12 col-form-label">
          {{ item.Cash }}
        </p>
    </div>
    </div>

    <div class="row">          
      <div class="titleHr">
        <span>支付調整</span>
      </div>
    </div>


    <div class="row rowTop" *ngFor="let adjust of AdjustTransactionMo.adjustList; let i = index">
      <div class="row mx-0 col-sm-6">
        <nb-select fullWidth [(ngModel)]="adjust.paymentKindId" name="paymentKind{{i}}">
          <nb-option *ngFor="let method of AdjustTransactionMo.paymentList" [value]="method.value">
            {{ method.content }}
          </nb-option>
        </nb-select>
      </div>
      <div class="row mx-0 col-sm-6">
        <input nbInput type="number" [(ngModel)]="adjust.amount" name="amount{{i}}" />
      </div>
      <div class="row mx-0 col-sm-12">
        <button nbButton fullWidth (click)="AdjustTransactionMo.removePayment(i)">移除</button>
      </div>
    </div>
  
  </nb-card-body>

  <button nbButton class="m-0 col-12" (click)="AdjustTransactionMo.addPayment()">新增付款方式</button>
  
  <nb-card-footer>
    <button nbButton (click)="AdjustTransactionMo.onSave()">儲存</button>
    <button nbButton (click)="ref.close()">關閉</button>
  </nb-card-footer>

</nb-card>
</form>
</ng-template>